import { useState } from "react";

const API_URL = "https://api.gosehari.com";

function ItineraryDetails({ routeMap }) {
    const [showImage, setShowImage] = useState(false);
    const imageUrl = routeMap?.image_path
        ? (routeMap.image_path.startsWith("http") ? routeMap.image_path : `${API_URL}${routeMap.image_path}`)
        : null;

    if (!imageUrl) return null;

    return (
        <>
            <div className="relative inline-block max-w-full group">
                <div

                    className="text-black mb-4 text-center font-bold"
                >
                    📍 Show Route Map
                </div>

                <img
                    src={imageUrl}
                    alt="Route map"
                    onClick={() => setShowImage(true)}
                    className="block h-auto max-w-full cursor-pointer rounded-xl transition duration-300 hover:scale-105"
                />

                {/* Tooltip */}
                <div className="pointer-events-none absolute -top-12 left-1/2 z-50 -translate-x-1/2 opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:-translate-y-1">
                    <div className="whitespace-nowrap rounded-lg bg-gray-900 px-3 py-2 text-sm font-medium text-white shadow-xl">
                        🔍 Click to view full image
                    </div>

                    {/* Arrow */}
                    <div className="mx-auto h-3 w-3 -translate-y-1 rotate-45 bg-gray-900"></div>
                </div>
            </div>



            {showImage && (
                <div
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
                    onClick={() => setShowImage(false)}>
                    <div
                        className="relative max-w-6xl w-full"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setShowImage(false)}
                            className="absolute right-0 top-0 h-10 w-10 rounded-full bg-white text-xl font-bold shadow-lg hover:bg-gray-100 sm:-right-4 sm:-top-4"
                        >
                            ×
                        </button>

                        <img
                            src={imageUrl}
                            alt="Route map preview"
                            className="w-full max-h-[90vh] object-contain rounded-2xl"
                        />
                    </div>

                </div>
            )}
        </>
    )
}

export default ItineraryDetails
